import { render, staticRenderFns } from "./studentOrderDetail.vue?vue&type=template&id=110b4d88&"
import script from "./studentOrderDetail.vue?vue&type=script&lang=js&"
export * from "./studentOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentOrderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports